import smartSolveApi from './instances/smartsolve';

export const sendBatchUpdate = async ({ clientChanges, bulkEditData, formKey }) => {
  try {
    const response = await smartSolveApi.post('/batchupdate', {
      clientChanges,
      formKey,
      ...bulkEditData,
    });

    return response;
  } catch (e) {
    throw new Error(`sendBatchUpdate() failed: ${e}`);
  }
};
